import {actions} from 'mirrorx';

import DBController from '../controllers/dropbox-controller';
import FileProviders from '../enums/file-providers';

import Pages from '../enums/pages';

export default class IO {
	constructor(props) {
		this.props = props;
		this.setProps = this.setProps.bind(this);
		this.saveFile = this.saveFile.bind(this);
		this.newFile = this.newFile.bind(this);
		this.__onDropboxSuccess = this.__onDropboxSuccess.bind(this);
		this.openFile = this.openFile.bind(this);
		this.db = new DBController(this.props.services.dropboxClientId);
	}

	__isDropboxReady() {
	    return !!window.Dropbox;
	}

	newFile() {
		actions.editor.reset();
	}

	setProps(props) {
		this.props = props;
	}

	async saveFile() {
		if (this.props.editor.hasBeenSaved) {
  			return await this.db.saveToDropbox(this.props.editor.text, 
  				this.props.editor.file.path, this.props.editor.file.name);
	    }
	    else {
	    	// we need to show the save dialog instead
	    	actions.layout.setPage(Pages.SAVE_FILE);
	    	return false;
	    }
	}

	// not exported
	__onDropboxSuccess(files) {
		const file = files[0];
		this.db.loadFromDropboxLink(file.link).then(meta => {
			actions.autosave.addRecentPath({
				name: meta.name,
				path: meta.path,
				service: FileProviders.DROPBOX
			});
		});
	}

	openFile() {
		if (this.__isDropboxReady() ) {
    	window.Dropbox.choose({
    		success: this.__onDropboxSuccess
    	});
    }
	}
}



// WEBPACK FOOTER //
// ./src/singletons/io.js